var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "city-selector-inline" },
    [
      _c(
        "a-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            mode: "multiple",
            "filter-option": false,
            "not-found-content": _vm.fetching ? undefined : null,
          },
          on: {
            search: _vm.getCitiesBySearch,
            change: function () {
              return _vm.getCitiesBySearch()
            },
          },
          model: {
            value: _vm.selectedCities,
            callback: function ($$v) {
              _vm.selectedCities = $$v
            },
            expression: "selectedCities",
          },
        },
        [
          _vm.fetching
            ? _c("a-spin", {
                attrs: { slot: "notFoundContent", size: "small" },
                slot: "notFoundContent",
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.items, function (item) {
            return _c(
              "a-select-option",
              { key: item.key, attrs: { value: item.key } },
              [_vm._v("\n            " + _vm._s(item.value) + "\n        ")]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }